import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { getDefaultRecipe } from './utils/get-default-recipe';

const MAX_COMPONENT_TRACE_LENGTH = 4000; // slightly less than 4KB to be safe

/*
  Renders only default Recipe component in case of errors in Experiment component.
 */
export class ExperimentErrorBoundary extends Component {
  static propTypes = {
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  };

  static defaultProps = {
    children: null,
    message: null,
  };

  state = {
    hasError: false,
  };

  // eslint-disable-next-line class-methods-use-this
  componentDidCatch(error, info) {
    if (window?.newrelic) {
      const truncatedStack = `${info.componentStack.substring(0, MAX_COMPONENT_TRACE_LENGTH)}... [truncated]`;

      window.newrelic.noticeError(error, {
        react_experiment_error_boundary: 'true',
        component_stack: truncatedStack,
      });
    }
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  render() {
    const { children } = this.props;
    if (this.state.hasError) {
      const defaultRecipe = getDefaultRecipe(children.props);
      return React.cloneElement(defaultRecipe);
    }
    return this.props.children;
  }
}
